<template>
  <div id="about-page" class="pageContainer">
    <div class='wall'></div>
    <div id="about-contents">
      <div id="spaceholder"></div>
      <div id="line"></div>
      <div id="contents">
        <div class="content-padding"></div>
        <div class="title" content='arttech' v-on:click="openDetail" ><span>art <span class="cross">x</span> technology</span></div>
        <div class="detail" content='arttech'>
          <AboutArtTech :active=isAboutTechActive></AboutArtTech>
        </div>
        <div class="title" content='community' v-on:click="openDetail"><span>community <span class="cross">x</span> background</span></div>
        <div class="detail"  content='community' >
          <Background :active=isCommunity></Background>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

	import BaseView from '@/components/BaseView'
  import AboutArtTech from '@/components/AboutArtTech'
  import Background from '@/components/Background'
	import Component from 'vue-class-component'
    @Component({
      components: {
       AboutArtTech,
       Background
      }
    })
  export default class About extends BaseView {
    isAboutTechActive = false;
    isCommunity       = false;
    mounted(){
      setTimeout( function(){
        this.$el.classList.add('active');
        this.openDetail( event, 'arttech' )
      }.bind(this), 100);
    }



    openDetail( event, _nextDetail=null ){
      const nextDetail = _nextDetail || ( event.target.getAttribute("content") ||
                            event.target.parentNode.getAttribute("content") );
      let el = this.$el.querySelector(".detail.active");
      if( el ){  
        el.classList.remove('active');
        const currentDetail = el.getAttribute('content');
        switch( currentDetail ) {
          case "arttech":
            this.isAboutTechActive = false;
            break;
          case "community":
            this.isAboutTechActive = false;
            break;
        }
        if( currentDetail == nextDetail ) {
          return;
        }
      }
      el = this.$el.querySelector('.detail[content="'+nextDetail+'"]');
      el.classList.add("active");
      switch( nextDetail ) {
        case "arttech":
          this.isAboutTechActive = true;
          break;
        case "community":
          this.isCommunity = true;
          break;
      }
    }

	}

</script>
<style lang="scss">
  #about-page{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    div.wall {
      position: fixed;
      bottom: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      margin: 0px;
      padding: 0px;
      background-image: url( ../assets/images/with_glass_photo_bw.png);
      background-repeat: no-repeat;
      background-size: 30% auto;
      background-position: right bottom;
      transform: translateY(10px);
      opacity: 0;
      transition: transform 1s ease-in-out 0s, opacity .3s ease-in-out 0.1s;  
      z-inde:-1;   
    }
    &.active{
      div.wall{
        transform: translateY(0px);
        opacity:0.5;
      }
      #about-contents{
        #line{
          width: calc(100% - 3em);
          height: 2px;
          opacity: 1;
          margin-left: 3em;
        }
        #contents {
          > div {
            &:nth-child(2) {
              transition-delay: 0.1s;
            }
            &:nth-child(3) {
              transition-delay: 0.1s;
            }
            &:nth-child(4) {
              transition-delay: 0.5s;
            }
            &:nth-child(5) {
              transition-delay: 0.1s;
            }
            &:nth-child(6) {
              transition-delay: 0.8s;
            }
            &:nth-child(7) {
              transition-delay: 0.1s;
            }
            opacity:1;
            margin-left: 0px;
            margin-top: 0px;
            &.title{
              opacity: 0.8;
              &:hover{
                opacity:1;
              }
              margin-left: 0px;
              margin-top: 0px;
            }
          }
        }
        @media only screen and (max-width: 600px) {
          #line{
            height:100%;
            width:2px;
            margin-left:0px;
          }
        }
      }
    }
    #about-contents{
      display:flex;
      flex-direction: column;
      width:100%;
      height: 100%;
      #spaceholder{
        height:10vh;
      }
      #line{
        opacity: 0;
        height: 2px;
        width: 1px;
        transition: all 0.75s ease-in-out 0.1s;     
        transform-origin:top left;
        background: #FFF;
      }
      #contents{
        > div {
          opacity:0;
          margin-left: 50px;
          margin-top: 0px;
          transition: opacity 1.5s ease, width 0.5s linear, height 0.5s linear, margin 2s cubic-bezier(.08,.81,.31,.99),
            flex 1s cubic-bezier(.08,.81,.31,.99);     
        }
        display:flex;
        flex-direction: row;
        flex:1;
        .detail {
          flex: none;
          width: 0%;
          height: 100%;
          box-sizing: border-box;
          padding: 0em;
          opacity: 0;
          overflow:hidden;
          position:relative;

          &.active{
            position: relative;
            opacity: 0.8;
            padding: 1.5em;
            flex: 1;
            width: 0%;
            height: 100%;
            display: block;

            background:rgba(249,249,249, 0.5);
            visibility: visible;
          }
        }

        > div.title{
          padding-left: 20px;
          pointer-events: all;
          cursor: pointer;
          position: relative;
          transform-origin: 0.5em 0.5em;
          transform: rotateZ(90deg);
          vertical-align: middle;
          position: relative;
          width: 0.5em;
          white-space: nowrap;
          font-size: 2em;
          &:before {
            content: "";
            left: -10px;
            top:  0.25em;
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.5);
            position: absolute;
            z-index: 1;
            -webkit-animation: bubble 5s ease-in-out infinite both alternate, movement 10s ease-in-out infinite both;
            animation: bubble 5s ease-in-out infinite both alternate, movement 10s ease-in-out infinite both;
            vertical-align: middle;
          }
          &:hover {
            &:before{
              background: rgba(255, 255, 255, 1.0);
            }
            span{
              background: linear-gradient(to right, var(--basecolor) 50%, #9a839e 60%, #9a839e 70%, #7fb5b9 80%, #756f64 100%);
              background-size: 300% auto;  
              color: #000;
              background-clip: text;
              text-fill-color: transparent;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              animation-iteration-count: 1;
              animation-fill-mode: forwards;
              animation: shine 1s ease;
              @keyframes shine {
                0% {
                  background-position: 300% center;
                }
                50% {
                  background-position: 200% center;
                }

                to {
                  background-position: 0% center;
                }
              }
              
            }
          }


        }
        .content-padding{
            width: 9.5em;
            height: 100%;
        }

      }
    }
    @media only screen and (max-width: 600px) {
      #about-contents{
        flex-direction: row;
        #spaceholder{
          width:5vh;
        }
   
        #line{
          width:2px;
          height:1px;

        }
        #contents{
          flex-direction: column;
          > div {
            margin-left: 0px;
            margin-top: 50px;
          }
          .content-padding{
              width: 100%;
              height: 9em;
          }


          .detail {
            height: 0px;
            width:100%;
            visibility: hidden;
            overflow:hidden;
            &.active{
              flex: 1;
              width: 100%;
              height: auto;
              background:rgba(249,249,249, 0.5);
              visibility: visible;
              overflow:hidden;

            }
          }


          >div.title{
            font-size:2em;
            transform: rotateZ(0deg);
            vertical-align: middle;
            &:before {
              content: "";
              top: 0.25em;
              left: -10px;
              display: inline-block;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.8);
              z-index: 1;
              -webkit-animation: bubble 5s ease-in-out infinite both alternate, movement 10s ease-in-out infinite both;
              animation: bubble 5s ease-in-out infinite both alternate, movement 10s ease-in-out infinite both;
              vertical-align: middle;
              position: absolute;

            }
          }
        }
      }
    }
  }
</style>